import Cookies from "js-cookie";

const EXPERIMENT_COOKIE = "EXPERIMENTS";
const EXPERIMENT_COOKIE_DOMAIN = "yourgolftravel.com";

const getExperimentCookieDomain = (): string | undefined => {
  const hostname = window.location.hostname;
  if (
    hostname === EXPERIMENT_COOKIE_DOMAIN ||
    hostname.endsWith(`.${EXPERIMENT_COOKIE_DOMAIN}`)
  ) {
    return EXPERIMENT_COOKIE_DOMAIN;
  }
  return undefined;
};

const setExperimentCookie = (newCookie: string): void => {
  const domain = getExperimentCookieDomain();
  Cookies.set(EXPERIMENT_COOKIE, newCookie, {
    expires: 9999,
    sameSite: "lax",
    domain,
    path: "/",
  });
};

const clearExperimentCookie = (): void => {
  const domain = getExperimentCookieDomain();
  Cookies.remove(EXPERIMENT_COOKIE, { domain, path: "/" });
};

export const initExperiments = (): void => {
  // One-time cleanup: remove legacy cookie set without explicit domain.
  // Old cookies were scoped to the exact hostname (e.g. www.yourgolftravel.com).
  // The new cookie is set on .yourgolftravel.com. Without this, both cookies
  // coexist and the browser sends both under the same name.
  if (getExperimentCookieDomain()) {
    Cookies.remove(EXPERIMENT_COOKIE, { path: "/" });
  }
  // Process experiments queue from Rails views
  if (window.experimentsQueue && window.experimentsQueue.length > 0) {
    window.experimentsQueue.forEach((exp) => {
      if (exp.action === "set" && exp.cookie) {
        setExperimentCookie(exp.cookie);
      } else if (exp.action === "clear") {
        clearExperimentCookie();
      }
    });
    // Clear the queue now that the work is done
    window.experimentsQueue = [];
  }
};

export default initExperiments;
